import CommonIndex from '@/views/CommonIndex.vue';

export default {
  path: '/',
  alias: '/home',
  name: 'Home',
  meta: {
    icon: 'home',
  },
  component: CommonIndex as any,
  redirect: '/content-marketing/content-insights',
};
